module.exports = __webpack_public_path__ + "img/23.057e21fa.jpg";